import React, { useEffect, useRef, useState } from "react";
import { HiMicrophone } from "react-icons/hi2";
import { IoSearchOutline } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import { toggleMenu } from "../utils/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { YOUTUBE_SERACH_API, YOUTUBE_SERACH_RESULTS } from "../utils/constants";
import logo from "../Assets/Logo.png";
import { cacheResults } from "../utils/searchSlice";
import { addSearchResults } from "../utils/searchResults";
import { CiBellOn } from "react-icons/ci";
import { PiVideoCameraLight } from "react-icons/pi";
import favicon from "../Assets/favicon.ico";
import { API_KEY } from "../utils/constants";

const Head = () => {
  const dispatch = useDispatch();
  const [searchQuery, setsearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setshowSuggestions] = useState(false);
  const searchCache = useSelector((store) => store.search);
  const searchText = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchCache[searchQuery]) {
        setSuggestions(searchCache[searchQuery]);
      } else {
        getSearchSuggestions();
      }
    }, 200);
    return () => {
      clearTimeout(timer);
    };
  }, [searchQuery]);

  const getSearchSuggestions = async () => {
    const data = await fetch(YOUTUBE_SERACH_API + searchQuery);
    const json = await data.json();

    setSuggestions(json[1]);
    console.log("setSuggestions(json[1]) :>> ", json[1]);
    dispatch(
      cacheResults({
        [searchQuery]: json[1],
      })
    );
  };

  const showSearchResults = async () => {
    const res = searchText.current.value;
    const data = await fetch(YOUTUBE_SERACH_RESULTS + res + "&key=" + API_KEY);
    const json = await data.json();
    dispatch(addSearchResults(json.items));
  };

  const toggleMenuHandler = () => {
    dispatch(toggleMenu());
  };

  return (
    <div className=" grid grid-flow-col p-2 mx-2  items-center fixed top-0 w-full bg-white z-10">
      <div className="flex col-span-1 items-center mx-3 ">
        <RxHamburgerMenu
          className="h-8 mr-6  cursor-pointer hidden md:inline-block"
          size={24}
          onClick={() => toggleMenuHandler()}
        />
        <a href="/">
          <img className="h-10 w-32  " src={logo} alt="logo" />
        </a>
      </div>
      <div className="col-span-10 mx-auto  ">
        <div className="mx-auto flex items-center ">
          <input
            ref={searchText}
            className="w-[33rem] hidden md:inline-block  h-10  px-4 rounded-l-full p-2 border border-gray-400"
            placeholder="Search"
            type="text"
            value={searchQuery}
            onChange={(e) => setsearchQuery(e.target.value)}
            onFocus={() => setshowSuggestions(true)}
            onBlur={() => setshowSuggestions(false)}
          />

          <button
            onClick={showSearchResults}
            className="cursor-pointer   hover:bg-gray-200      flex justify-center items-center  w-16 h-10  md:rounded-r-full md:border border-gray-400 md:bg-gray-100"
          >
            <IoSearchOutline size={20}/>
          </button>

          <button className="cursor-pointer w-10 h-10  hidden   hover:bg-gray-200 mx-2  md:flex justify-center items-center  rounded-full border border-gray-400 bg-gray-100">
            <HiMicrophone />
          </button>
        </div>
        {showSuggestions && suggestions.length > 0 && (
          <div className="fixed bg-white w-[33rem] py-2 px-5 border border-gray-100 rounded-lg ">
            <ul>
              {suggestions.map((s) => (
                <li
                  key={s}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => console.log("clicked")}
                >
                  {/* <IoSearchOutline className="inline-block mx-2" /> */}
                  {s}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className=" col-span-1  flex items-center justify-evenly p-2 ">
        <button className="cursor-pointer w-10 h-10 hidden   md:flex items-center justify-center hover:bg-gray-200   rounded-full ">
          <PiVideoCameraLight size={24} />
        </button>
        <button className="cursor-pointer w-10 h-10  hidden   md:flex items-center justify-center hover:bg-gray-200   rounded-full ">
          <CiBellOn size={24} />
        </button>

        <img
          className="cursor-pointer w-9 h-9 object-contain rounded-full border border-gray-400 shadow-sm"
          alt="profilePic"
          src={favicon}
        ></img>
      </div>
    </div>
  );
};

export default Head;
